import AdminDashboard from "../pages/Admin/Dashboard/AdminDashboard";

import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import Profile from "../pages/Admin/Profile/Profile";
import Color from "../pages/Admin/Colors/Colors";
import Transmission from "../pages/Admin/Transmissions/Transmissions";
import Feature from "../pages/Admin/Features/Features";
import Fuel from "../pages/Admin/Fuels/Fuels";
import Country from "../pages/Admin/Countries/Countries";
import VehicleType from "../pages/Admin/VehicleTypes/VehicleTypes";
import Make from "../pages/Admin/Makes/Makes";
import Model from "../pages/Admin/Models/Models";
import ModelCode from "../pages/Admin/ModelCodes/ModelCodes";
import Vehicle from "../pages/Admin/Vehicle/Vehicle";
import Vehicles from "../pages/Admin/Vehicles/Vehicles";
import VehicleEdit from "../pages/Admin/Vehicles/VehicleEdit/VehicleEdit";
import VehicleCostSheet from "../pages/Admin/Vehicles/VehicleCostSheet/VehicleCostSheet";
import Order from "../pages/Admin/Orders/Orders";
import Staff from "../pages/Admin/Staff/Staff";
import CustomerRequests from "../pages/Admin/CustomerRequests/CustomerRequests";
import CreateOrder from "../pages/Admin/Orders/CreateOrder/CreateOrder";
import ViewOrder from "../pages/Admin/Orders/Order/ViewOrder";
import Options from "../pages/Admin/Options/Options";
import ViewPayment from "../pages/Admin/Orders/Order/Payment/ViewPayment";
import InsertDocument from "../pages/Admin/Orders/Order/InsertDocument/InsertDocument";
import Customer from "../pages/Admin/Customers/Customer";
import CustomerLedger from "../pages/Admin/Customers/CustomerLedger/CustomerLedger";
import Banner from "../pages/Admin/Banners/Banner";
import Inquiries from "../pages/Admin/Inquiries/Inquiries";
import BannerCreate from "../pages/Admin/Banners/BannerCreate/BannerCreate";
import ViewInquiry from "../pages/Admin/Inquiries/ViewInquiry/ViewInquiry";
import NewCustomer from "../pages/Admin/Customers/NewCustomer/NewCustomer";
import Invoice from "../pages/Admin/Vehicles/Invoice/Invoice";
import Invoices from "../pages/Admin/Vehicles/Invoices/Invoices";
import EditInvoice from "../pages/Admin/Vehicles/Invoices/EditInvoice/EditInvoice";

var AdminRoutes = [
  {
    path: "dashboard",
    name: "Dashboard",
    element: <AdminDashboard />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "vehicle",
    name: "New Vehicle",
    element: <Vehicle />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "vehicles",
    name: "Vehicles",
    element: <Vehicles />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "orders",
    name: "Orders",
    element: <Order />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "requests",
    name: "Customer Requests",
    element: <CustomerRequests />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "staff",
    name: "Staff Members",
    element: <Staff />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "customer",
    name: "Customers",
    element: <Customer />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "banner",
    name: "Banners",
    element: <Banner />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "inquiries",
    name: "Inquiries",
    element: <Inquiries />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "options",
    name: "Options",
    element: <Options />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "vehicles/:id",
    name: "Vehicle Edit",
    element: <VehicleEdit />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "vehicles/:id&cost",
    name: "Vehicle Cost Sheet",
    element: <VehicleCostSheet />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "orders/create-order",
    name: "New Order",
    element: <CreateOrder />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "orders/:id",
    name: "Order",
    element: <ViewOrder />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "orders/:id/document",
    name: "Document",
    element: <InsertDocument />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "orders/:orderId/:id",
    name: "Payment",
    element: <ViewPayment />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "options/colors",
    name: "Colors",
    element: <Color />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "options/transmissions",
    name: "Transmissions",
    element: <Transmission />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "options/features",
    name: "Features",
    element: <Feature />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "options/fuels",
    name: "Fuel Types",
    element: <Fuel />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "options/countries",
    name: "Countries",
    element: <Country />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "options/vehicle-types",
    name: "Vehicle Types",
    element: <VehicleType />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "options/makes",
    name: "Makes",
    element: <Make />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "options/models",
    name: "Models",
    element: <Model />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "options/model-codes",
    name: "Model Codes",
    element: <ModelCode />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "profile",
    name: "Profile",
    element: <Profile />,
    layout: 'admin',
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon
  },
  {
    path: "customer/ledger/:id",
    name: "Customer Ledger",
    element: <CustomerLedger />,
    layout: 'admin',
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon
  },
  {
    path: "banner/create-banner",
    name: "Create Banner",
    element: <BannerCreate />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "inquiries/:id",
    name: "Inquiry",
    element: <ViewInquiry />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "customer/create-customer",
    name: "New Customer",
    element: <NewCustomer />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "vehicles/invoice/:id",
    name: "Vehicle Invoice",
    element: <Invoice />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "vehicles/:id/invoices",
    name: "Vehicle Invoices",
    element: <Invoices />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "vehicles/:id/invoices/:invoiceId",
    name: "Edit Invoice",
    element: <EditInvoice />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default AdminRoutes;
